/* eslint-disable sort-keys-fix/sort-keys-fix */

import { ISwatch } from '@/components/colorSwatches';
import { getTailWindColors } from '@/utils/common';

const { 'customize-swatch': customizeSwatch } = getTailWindColors();

export enum CustomizeColorSwatchEnum {
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  BLUE = 'blue',
  PINK = 'pink',
  BLACK = 'black',
  WHITE = 'white',
  STRIPED = 'striped',
  NONE = 'none',
}

export const customizeSwatchConfig: { [key: string]: ISwatch } = {
  [CustomizeColorSwatchEnum.RED]: {
    class: 'bg-customize-swatch-red',
    id: CustomizeColorSwatchEnum.RED,
    color: customizeSwatch.red,
  },
  [CustomizeColorSwatchEnum.ORANGE]: {
    class: 'bg-customize-swatch-orange',
    id: CustomizeColorSwatchEnum.ORANGE,
    color: customizeSwatch.orange,
  },
  [CustomizeColorSwatchEnum.YELLOW]: {
    class: 'bg-customize-swatch-yellow',
    id: CustomizeColorSwatchEnum.YELLOW,
    color: customizeSwatch.yellow,
  },
  [CustomizeColorSwatchEnum.GREEN]: {
    class: 'bg-customize-swatch-green',
    id: CustomizeColorSwatchEnum.GREEN,
    color: customizeSwatch.green,
  },
  [CustomizeColorSwatchEnum.BLUE]: {
    class: 'bg-customize-swatch-blue',
    id: CustomizeColorSwatchEnum.BLUE,
    color: customizeSwatch.blue,
  },
  [CustomizeColorSwatchEnum.PINK]: {
    class: 'bg-customize-swatch-pink',
    id: CustomizeColorSwatchEnum.PINK,
    color: customizeSwatch.pink,
  },
  [CustomizeColorSwatchEnum.BLACK]: {
    class: 'bg-customize-swatch-black',
    id: CustomizeColorSwatchEnum.BLACK,
    color: customizeSwatch.black,
  },
  [CustomizeColorSwatchEnum.WHITE]: {
    class: 'bg-customize-swatch-white border-1 border-gray-100',
    id: CustomizeColorSwatchEnum.WHITE,
    color: customizeSwatch.white,
  },
  [CustomizeColorSwatchEnum.STRIPED]: {
    class: 'bg-striped-pattern',
    id: CustomizeColorSwatchEnum.STRIPED,
    color: customizeSwatch.white,
  },
  [CustomizeColorSwatchEnum.NONE]: {
    class: `bg-diagnal-pattern`,
    id: CustomizeColorSwatchEnum.NONE,
    color: 'transparent',
  },
};
